var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 3.99967V7.99967L11.1666 9.33301M15.1666 7.99967C15.1666 11.6816 12.1818 14.6663 8.49992 14.6663C4.81802 14.6663 1.83325 11.6816 1.83325 7.99967C1.83325 4.31778 4.81802 1.33301 8.49992 1.33301C12.1818 1.33301 15.1666 4.31778 15.1666 7.99967Z",
    stroke: "#2E1A47",
    strokeOpacity: 0.5,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1d7456c7a48c017043e504133582a845.svg";
export { ForwardRef as ReactComponent };